var List_obj = {};
/**
 * 协议状态集合
 * @type {*[]}
 */

List_obj.protocolStatusList = [{
  codeCode: '00',
  codeName: '全部'
}, {
  codeCode: '02',
  codeName: '待补录'
}, {
  codeCode: '03',
  codeName: '暂存'
}, {
  codeCode: '04',
  codeName: '待审核'
}, {
  codeCode: '05',
  codeName: '生效'
}, {
  codeCode: '06',
  codeName: '审核驳回'
}, {
  codeCode: '07',
  codeName: '待保险公司内部审核'
}, {
  codeCode: '08',
  codeName: '保险公司内部审核驳回'
}];
List_obj.trueOrFalse = [{
  codeCode: '1',
  codeName: '是'
}, {
  codeCode: '0',
  codeName: '否'
}];
/**
 * 有无包装
 * @type {*[]}
 */

List_obj.isPackagingFlag = [{
  codeCode: '1',
  codeName: '有'
}, {
  codeCode: '0',
  codeName: '无'
}];
List_obj.inSureTypeList = [{
  placeholder: '请输入被保险人名称',
  name: '被保险人名称',
  input: 'insuredName',
  type: 'input',
  isrequir: true
}, {
  placeholder: '请输入被保险人英文名称',
  name: '被保险人英文名称',
  input: 'insuredEnName',
  type: 'input',
  isrequir: false
}, {
  placeholder: '请选择证件类型',
  name: '证件类型',
  input: 'idEntifyTypeCode',
  type: 'select',
  isrequir: true
}, {
  placeholder: '请输入证件号',
  name: '证件号',
  input: 'identifyNumber',
  type: 'input',
  isrequir: true
}, {
  placeholder: '请输入地址',
  name: '地址',
  input: 'address',
  type: 'input',
  isrequir: true
}, {
  placeholder: '请输入邮箱',
  name: '邮箱',
  input: 'email',
  type: 'input',
  isrequir: false
}, {
  placeholder: '请输入电话',
  name: '电话',
  input: 'phone',
  type: 'input',
  isrequir: false
}, {
  placeholder: '请选择单位性质',
  name: '单位性质',
  input: 'unitNature',
  type: 'selectUnitNature',
  isrequir: false
}, {
  placeholder: '请选择境内外标识',
  name: '境内外标识',
  input: 'nationalFlag',
  type: 'selectNationalFlag',
  isrequir: false
}, {
  placeholder: '请选择省市区',
  name: '省市区',
  input: 'provinceLists',
  type: 'insuredProvince',
  isrequir: false
}];
List_obj.clauseAttributeList = [{
  codeCode: '1',
  codeCname: '主险'
}, {
  codeCode: '2',
  codeCname: '附加险'
}];
/**
 * 可选费率因子
 * @type {Array}
 */

List_obj.freightRateList = [{
  codeCode: '1',
  codeCname: '运输区间'
}, {
  codeCode: '2',
  codeCname: '是否集装箱'
}, {
  codeCode: '3',
  codeCname: '包装'
}, {
  codeCode: '4',
  codeCname: '运输方式'
}, {
  codeCode: '5',
  codeCname: '特殊加成比例'
}];
List_obj.selectCondList = [{
  codeCode: '1',
  codeCname: '标的类型'
}, {
  codeCode: '2',
  codeCname: '运输方式'
}, {
  codeCode: '3',
  codeCname: '是否冷藏'
}, {
  codeCode: '4',
  codeCname: '有无包装'
}],
/**
 * 可选影响因子
 * @type {*[]}
 */
List_obj.influenceList = [{
  codeCode: '1',
  codeCname: '运输方式'
}, {
  codeCode: '2',
  codeCname: '标的'
}];
/**
 * 国内外标志
 * @type {*[]}
 */

List_obj.nationalType = [{
  codeCode: '1',
  codeCname: '国内'
}, {
  codeCode: '2',
  codeCname: '国外'
}];
/**
 * 账户类型(平台开通板块) --1、金融保险板块 2、金融银行板块
 * @type {*[]}
 */

List_obj.accountTypeList = [{
  codeCode: '1',
  codeCname: '金融保险板块'
}, {
  codeCode: '2',
  codeCname: '金融银行板块'
}];
/**
 * 业务类型(平台开通业务) --1、货物运输保险 2、短期出口贸易信用险 3、进口食安全综合保险 4、临港平台保险
 * @type {*[]}
 */

List_obj.businessTypeList = [{
  codeCode: '100',
  codeCname: '货物运输保险'
}, {
  codeCode: '101',
  codeCname: '短期出口贸易信用险'
}, {
  codeCode: '102',
  codeCname: '进口食安全综合保险'
}, {
  codeCode: '103',
  codeCname: '临港平台保险'
}];
/**
 * 状态 --0、无效  1、有效
 * @type {*[]}
 */

List_obj.statusList = [{
  codeCode: '0',
  codeCname: '无效'
}, {
  codeCode: '1',
  codeCname: '有效'
}];
/**
 * 注册来源
 * @type {[]}
 */

List_obj.userTypeList = [{
  codeCode: '0',
  codeCname: '平台注册'
}, {
  codeCode: '1',
  codeCname: '单一窗口引流'
}, {
  codeCode: '2',
  codeCname: '临港服务平台引流'
}];
/**
 *业务板块
 */

List_obj.businessPlateList = [{
  codeCode: '01',
  codeCname: '货物运输保险'
}, {
  codeCode: '02',
  codeCname: '临港平台保险'
}, {
  codeCode: '03',
  codeCname: '进口食品安全综合保险'
}, {
  codeCode: '04',
  codeCname: '短期出口贸易信用保险'
}];
/**
 *平台险种 四个业务下的险种
 */

List_obj.riskCodeList = [{
  codeCode: 'CINL',
  codeCname: '陆上运输货物保险'
}, {
  codeCode: 'CEXP',
  codeCname: '出口货物运输保险'
}, {
  codeCode: '03',
  codeCname: '进口货物运输保险'
}, {
  codeCode: '04',
  codeCname: '短期出口贸易信用保险'
}];
/**
 * 子账号
 */

List_obj.subAccountTypeList = [{
  codeCode: '01',
  codeCname: '被保人'
}];
export default List_obj;